__turbopack_context__.v({
  "card": "I0rlha_card",
  "container": "I0rlha_container",
  "partner": "I0rlha_partner",
});
